import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/lathe.jpg'


const _hoisted_1 = { style: {"margin-top":"5em"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-muted text-center pb-4" }, "custom whistles", -1)
const _hoisted_3 = { class: "container text-center mb-5 w-75" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"50%"},
  class: "pb-5"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " There are technical restrictions regarding tube diameter, wall thickness, combination of materials etc. I can consult with you to arrive at something that works out. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkComponent = _resolveComponent("LinkComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("p", null, [
        _createVNode(_component_LinkComponent, {
          href: "/#contact",
          "link-text": "Contact me"
        }),
        _createTextVNode(" for a custom whistle made to your specifications. Available materials are aluminium, brass and different sorts of wood. ")
      ]),
      _hoisted_5
    ])
  ]))
}